export class TagsFactory {
  constructor(instance) {
    this.instance = instance;
  }

  listTags(filters) {
    const filtredParams = filters ? { ...filters } : {};

    if (filtredParams.initial || filtredParams.initial !== undefined)
      delete filtredParams.initial;
    return this.instance.get('/v1/tags', {
      params: filtredParams,
    });
  }

  showTag(id) {
    return this.instance.get(`/v1/tags/${id}`);
  }

  insertTag(data) {
    return this.instance.post('/v1/tags', data);
  }

  updateTag(id, data) {
    return this.instance.put(`/v1/tags/${id}`, data);
  }

  removeTag(id) {
    return this.instance.delete(`/v1/tags/${id}`);
  }
}

export default TagsFactory;
